import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_CAREER = "GET_LIST_CAREER";
export const GET_DETAIL_CAREER = "GET_DETAIL_CAREER";
export const SEARCH_CAREER = "SEARCH_CAREER";
export const UPDATE_CAREER = "UPDATE_CAREER";
export const SAVE_CAREER = "SAVE_CAREER";
export const DELETE_CAREER = "DELETE_CAREER";
export const SET_LIST_CAREER = "SET_LIST_CAREER";
export const SET_DETAIL_CAREER = "SET_DETAIL_CAREER";
export const SET_SEARCH_CAREER = "SET_SEARCH_CAREER";



const state = {
    career: [],
    careerDetail: [],
    searchCareer:[]
};

const getters = {
    career(state) {
        return state.career;
    },
    careerDetail(state) {
        return state.careerDetail;
    },
    searchCareer(state) {
        return state.searchCareer;
    },

};

const actions = {
    [GET_LIST_CAREER](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_CAREER}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_CAREER, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_CAREER](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_CAREER}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_CAREER, data);
                }
                resolve(data);
            });
        });
    },
    [SEARCH_CAREER](context,payload) {
        return new Promise(resolve => {
            ApiService.query(`${API.SEARCH_CAREER}`,payload).then(({data}) => {
                if (data.status) {
                    context.commit(SET_SEARCH_CAREER, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_CAREER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_CAREER}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_CAREER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_CAREER}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_CAREER](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_CAREER}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_CAREER](state, data) {
        state.career = data.data;
    },
    [SET_DETAIL_CAREER](state, data) {
        state.careerDetail = data.data;
    },

    [SET_SEARCH_CAREER](state, data) {
        state.searchCareer = data.data;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};